export const chapterList = 
  {
    id: 2,
    name: 'РАЗДЕЛ 2',
    descr: `Новые профессии, востребованные на&nbsp;арктических территориях`,
    list: [
      {
        id: 1,
        text: 'Оператор снегоуплотнительных машин',
        department: {
          title: `СТРОИТЕЛЬСТВО`,
          list: [
            `ООО «Порт Лиинахамари»<br>(Мурманская область)`,
          ],
        },
        img: '/p2/1/b1.svg',
        list: [
          `Осведомленность о принципе действия снегоуплотнительной машины, ее функциях и особенностях, необходимом техническом обслуживании`,
          `Профессиональная обработка горнолыжных склонов, работа с лебедкой, фрезой и отвалом`,
          `Использование правильного угла резки снежных объектов`,
          `Сервисное обслуживание оборудования по снегоуплотнительной деятельности – с учетом
          экстремально низких температур, перепадов температурного режима, а также спецификой ландшафта`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      },{
        id: 2,
        text: 'Домработница в кочевых жилищах (чумработница)',
        department: {
          title: `СЕЛЬСКОЕ, ЛЕСНОЕ ХОЗЯЙСТВО, ОХОТА, РЫБОЛОВСТВО И РЫБОВОДСТВО`,
          list: [
            `ТСО КМН НЕНЦЕВ РК «ТЫБЕРТЯ» (ОЛЕНЕВОД) (Республика Коми)`,
            `НО СРО КМН «Салякоптанская» (ЯНАО)`,
          ],
        },
        img: '',
        list: [
          `Оказание помощи оленеводу в хозяйственной деятельности по уходу и разведением оленей`,
          `Использование ручных и частично механизированных работ по уходу за откормочным и нагульным поголовьем оленей при различных видах содержания`,
          `Знание особенностей ведения хозяйства в чумах в условиях сезонных изменений в Арктике`,
          `Знание основ, устоев, обычаев и порядка бытовой и организационно-хозяйственной деятельности коренных народов севера`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      },{
        id: 3,
        text: 'Судовой врач',
        url: '/p2/',
        department: {
          title: `ДЕЯТЕЛЬНОСТЬ ПРОФЕССИОНАЛЬНАЯ, НАУЧНАЯ И ТЕХНИЧЕСКАЯ`,
          list: [
            `ФГБУ «Северное управление по гидрометеорологии и мониторингу окружающей среды» (Архангельская область)`,
          ],
        },
        img: '',
        list: [
          `Контроль за санитарно-гигиеническим состоянием экипажа судна и профилактика респираторных заболеваний и обморожений в условиях низких температур`,
          `Оказание медицинской помощи пациенту в неотложной или экстренной ситуациях`,
          `Проведение обследования пациентов с целью установления диагноза в условиях ограниченных возможностей оказания медицинской помощи`,
          `Проведение противоэпидемических мероприятий среди экипажа судна`,
          `Оказание медицинской помощи в условиях волнения моря`,
          `Широкие врачебные компетенции, выходящие за пределы одной специализации`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      },{
        id: 4,
        text: 'Специалист по теплосбережению  в условиях Арктики',
        department: {
          title: `ОБРАЗОВАНИЕ `,
          list: [
            `МБДОУ «Кустурский детский сад «Кэнчээри» Эвено-Бытантайского национального улуса (района)» (Республика Саха (Якутия))`,
          ],
        },
        img: '',
        list: [
          'Координация работ по выявлению, локализации и ликвидации аварий и повреждений, подготовке трубопроводов и оборудования тепловых сетей в условиях экстремально низких температур, обледенения, снеговой нагрузки, а также резко изменяющегося температурного режима',
          'Проведение инструментальных обследований и испытаний тепловых сетей и оборудования на жилищных и производственных площадях АЗ РФ',
          'Обеспечение исправной работы автоматических устройств и контрольно-измерительных приборов на теплопроизводстве',
          'Знание особенностей экосистем Арктической зоны РФ для минимизации негативного влияния на окружающую среду',
          'Владение знаниями и навыками выживания в экстремальных условиях Арктики',
        ],
      },{
        id: 5,
        text: 'Специалист по ведению режима ветропарка ',
        department: {
          title: `ОБЕСПЕЧЕНИЕ ЭЛЕКТРИЧЕСКОЙ ЭНЕРГИЕЙ, ГАЗОМ И ПАРОМ, КОНДИЦИОНИРОВАНИЕ ВОЗДУХА`,
          list: [
            `ООО «Энел Рус Винд Кола» (Мурманская область)`,
          ],
        },
        img: '',
        list: [
          'Выявление рисков повышенного износа и преждевременного выхода из строя ветряных электростанций в условиях экстремальных ветровых нагрузок, низких температур, обледенения, снеговой нагрузки',
          'Проведение экспертизы по выбору наиболее благоприятных зон по установке ветряных электростанций с учетом экстремальных климатических условий, влияния на арктические флору и фауну, путей миграции птиц, млекопитающих',
          'Мониторинг работы и эксплуатации ветряных установок, работающих на круглосуточной основе с учетом экстремальных климатических условий',
          'Знание особенностей экосистем Арктической зоны РФ для минимизации негативного влияния на окружающую среду',
          'Владение знаниями и навыками выживания в экстремальных условиях Арктики',
        ],
      },{
        id: 6,
        text: 'Метеоэнергетик',
        department: {
          title: `ГОСУДАРСТВЕННОЕ УПРАВЛЕНИЕ И ОБЕСПЕЧЕНИЕ ВОЕННОЙ БЕЗОПАСНОСТИ СОЦИАЛЬНОЕ ОБЕСПЕЧЕНИЕ`,
          list: [
            `Госкорпорация «Росатом» (Чукотский АО)`,
          ],
        },
        img: '',
        list: [
          `Оптимизация режимов эксплуатации генерирующих мощностей с учетом климатических условий`,
          `Прогноз уровня производства энергии в зависимости от долгосрочных метеопрогнозов, в т.ч. с учетом экстремально низких температур, обледенения, снеговой нагрузки, а также резко изменяющегося температурного режима`,
          `Компетенции по эксплуатации мобильных источников энергоснабжения на удаленных территориях АЗ РФ`,
          `Принятие оптимальных решений по энергообеспечению с точки зрения нагрузки на экологические системы Арктики`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      },{
        id: 7,
        text: 'Изготовитель рыбоводного оборудования',
        department: {
          title: `СЕЛЬСКОЕ, ЛЕСНОЕ ХОЗЯЙСТВО, ОХОТА, РЫБОЛОВСТВО И РЫБОВОДСТВО`,
          list: [
            `ООО «Русский Лосось» (Мурманская область)`,
          ],
        },
        img: '',
        list: [
          `Проектирование и изготовление рыбоводного оборудования с учетом особенностей разведения пород рыб, обитающих в акваториях северных рек и морей Северного Ледовитого океана`,
          `Контроль за функционированием системы рыбоводного оборудования, в том числе в естественных условиях с учетом низких температур, перепадов температурного режима, ветровых и снеговых нагрузок, обледенения`,
          `Знание особенностей экосистем Арктической зоны РФ для минимизации негативного влияния на окружающую среду`,
        ],
      },{
        id: 8,
        text: 'Универсальный специалист связи',
        department: {
          title: `ДЕЯТЕЛЬНОСТЬ В ОБЛАСТИ ИНФОРМАЦИИ И СВЯЗИ `,
          list: [
            `Красноярский филиал ПАО «Ростелеком» (Красноярский край)`,
          ],
        },
        img: '',
        list: [
          `Выполнение работ по настройке, регулировке и испытаниям оборудования связи (телекоммуникаций) с учетом низких температур, перепадов температурного режима, ветровых и снеговых нагрузок, обледенения`,
          `Резервирование оборудования и каналов связи с учетом низкого уровня развития информационно-коммуникационной инфраструктуры в АЗ РФ`,
          `Контроль проектных параметров и режимов работы оборудования связи (телекоммуникаций) с учетом низких температур, перепадов температурного режима, ветровых и снеговых нагрузок, обледенения`,
          `Проведение проверки технического состояния оборудования, трактов и каналов передачи`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      },{
        id: 9,
        text: 'Оператор подземной самоходной зарядной машины',
        department: {
          title: `ОБРАБАТЫВАЮЩИЕ ПРОИЗВОДСТВА`,
          list: [
            `Заполярный филиал ПАО «ГМК «Норильский никель» (Красноярский край)`,
          ],
        },
        img: '',
        list: [
          'Управление и обслуживание роботизированных систем, в том числе на опасных производствах и при работе с труднодоступными местами или микрообъектами, в условиях наличия многолетнемерзлых пород, низких температур, перепадов температурного режима, обледенения',
          'Знание особенностей регулировки гидравлики, топливной арматуры и тормозной системы ПДМ в экстремальных условиях',
          'Знание особенностей экосистем Арктической зоны РФ для минимизации негативного влияния на окружающую среду',
          'Владение знаниями и навыками выживания в экстремальных условиях Арктики',
        ],
      },{
        id: 10,
        text: 'Специалист по навигации в условиях арктики',
        department: {
          title: `ТРАНСПОРТИРОВКА И ХРАНЕНИЕ`,
          list: [
            `ПАО «Ленское объединенное речное пароходство» (Республика Саха (Якутия)`,
            `ФГУП Росморпорт Мурманский филиал (Мурманская область)`,
            `ОАО «Архангельский морской торговый порт»`,
          ],
        },
        img: '',
        list: [
          `Знание особенностей навигации в условиях наличия льда в арктических акваториях`,
          `Умение прокладывать оптимальные маршруты для плавательных средств с учетом ледовой обстановки, сложных гидрометеорологических условий`,
          `Принятие оптимальных решений с точки зрения нагрузки на экологические системы Арктики`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      },{
        id: 11,
        text: 'Оператор беспилотных летательных аппаратов для разведки месторождений',
        department: {
          title: `ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ`,
          list: [
            `ПАО «Газпром нефть» (ЯНАО, НАО, Республика Саха (Якутия))`,
            `ПАО НК «Роснефть» (ЯНАО, Мурманская область, Республика Саха (Якутия), Красноярский край, Республика Коми)`,
          ],
        },
        img: '',
        list: [
          `Навыки эксплуатации БЛА на удаленной местности в быстро меняющихся гидрометеорологических условиях (ветер, осадки), а также в условиях низкой освещенности (полярная ночь)`,
          `Контроль хода разработки месторождения и поиск новых месторождений с помощью беспилотных летательных аппаратов, оснащенных магнитометрами и другими геофизическими датчиками`,
          `Навыки использования противообледенительных систем для БЛА`,
          `Знание особенностей экосистем Арктической зоны РФ для минимизации негативного влияния на окружающую среду`,
          `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
        ],
      }
    ]
  }
